import { apiFetch } from './client';

export const getC2cSummary = (systemId) => apiFetch(`/c2c/summary?system_id=${systemId}`);
export const getC2cDevices = (systemId) => apiFetch(`/c2c/devices?system_id=${systemId}`);
